import { useState, useEffect } from "react";
const fallbackSrc = "/no-image-available-icon-vector.jpg";
const failedSrcs = new Set();

const getEffectiveSrc = (s) => (!s || failedSrcs.has(s) ? fallbackSrc : s);

const FallbackImg = ({ src, alt, ...props }) => {
  const [imgSrc, setImgSrc] = useState(() => getEffectiveSrc(src));

  useEffect(() => {
    setImgSrc(getEffectiveSrc(src));
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      {...props}
      onError={(e) => {
        if (failedSrcs.size > 500) failedSrcs.clear();
        failedSrcs.add(src);
        e.target.onerror = null;
        e.target.src = fallbackSrc;
        setImgSrc(fallbackSrc);
      }}
    />
  );
};

export default FallbackImg;
